export default "__VITE_ASSET__BDJsoF3I__"